import { CAREER } from '../data';

export default function Maker() {
  return (
    <section id="maker" className="lw-maker">
      <div className="lw-section lw-maker__inner">
        <div className="lw-maker__intro">
          <h2 className="lw-h2">만드는 사람</h2>
          <p className="lw-maker__body">
            NCSOFT에서 20년 동안 아이온1, 블레이드앤소울 모바일을 기획했고, 영어교육
            유튜브로 1만 명 넘는 구독자를 모았어요. 그 경험으로 지금은 1인 가구의
            일상에 필요한 작은 도구를 만듭니다.
          </p>
        </div>

        <div className="lw-maker__list">
          {CAREER.map((c) => (
            <div className="lw-career" key={c.place}>
              <span className="lw-career__period">{c.period}</span>
              <div className="lw-career__detail">
                <span className="lw-career__place">{c.place}</span>
                <span className="lw-career__note">{c.detail}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
